/**
 * 当前 L7 内部存在的地图版本
 */
export var Version = /*#__PURE__*/function (Version) {
  Version["GAODE1.x"] = "GAODE1.x";
  Version["GAODE2.x"] = "GAODE2.x";
  Version["MAPBOX"] = "MAPBOX";
  Version["DEFUALT"] = "DEFUALTMAP";
  Version["SIMPLE"] = "SIMPLE";
  Version["GLOBEL"] = "GLOBEL";
  return Version;
}({});